$(document).ready(function () {
  $('#cml_checkout_button, #checkout:not(.bss-b2b-customer-portal-nt-checkout-btn)').click(function (event) {
    var cartNoteTextarea = $('#Cart-note');
    var selectedProjectCode = $('#project_codes').val();
    var isProjectCodeVisible = $('#project_code').is(':visible');

    if (!cartNoteTextarea.val().trim()) {
      return false; // Prevent the form from being submitted
    }

    if (isProjectCodeVisible && !selectedProjectCode) {
      Swal.fire({
        title: 'Please select a project code before proceeding.',
        icon: 'warning',
        confirmButtonColor: '#28334A',
        confirmButtonText: 'OK',
        showCancelButton: false,
      });
      $('#project_code_error').show();
      $('#project_codes').focus();
      return false;
    } else {
      handleCheckout(selectedProjectCode, event);
    }
  });

  function handleCheckout(selectedProjectCode, event) {
    event.preventDefault();
    var attributeName = "Project Code";

    // Update the cart with a custom attribute
    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: {
        attributes: {
          [attributeName]: selectedProjectCode
        }
      },
      dataType: 'json',
      success: function () {
        // After successfully adding the attribute, continue to checkout
        window.location.href = '/checkout';
      },
      error: function () {
        alert('There was an issue updating your cart. Please try again.');
      }
    });
    return false; // To ensure the form doesn't submit before the AJAX call completes
  }
});
